import React, { useState } from "react";
import {
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText
} from "@mui/material";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import SyncOutlinedIcon from "@mui/icons-material/SyncOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import UndoOutlinedIcon from "@mui/icons-material/UndoOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";

// Cada ação só aparece no status a que pertence: Confirmar/Ignorar em Gerado,
// Integrar/Desconfirmar em Confirmado, Reconsiderar em Ignorado — nunca duas
// ações do mesmo par (ex.: Confirmar e Desconfirmar) ao mesmo tempo.
const MenuAcoesIntegracao = ({
    statusOS,
    completo = true,
    temOS = false,
    somenteLeitura = false,
    onConfirmar,
    onIntegrar,
    onDesconfirmar,
    onIgnorar,
    onReconsiderar,
    onVerHistorico,
    temHistorico = false,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const aberto = Boolean(anchorEl);

    const mostrarConfirmar = statusOS === "G";
    const mostrarIgnorar = statusOS === "G";
    const mostrarIntegrar = statusOS === "C";
    const mostrarDesconfirmar = statusOS === "C";
    const mostrarReconsiderar = statusOS === "X";

    const podeConfirmar = mostrarConfirmar && !somenteLeitura && completo && temOS;
    const podeIgnorar = mostrarIgnorar && !somenteLeitura && temOS;
    const podeIntegrar = mostrarIntegrar && !somenteLeitura && temOS;
    const podeDesconfirmar = mostrarDesconfirmar && !somenteLeitura && temOS;
    const podeReconsiderar = mostrarReconsiderar && !somenteLeitura && temOS;

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function executar(acao) {
        const botao = anchorEl;
        handleClose();
        acao?.(botao);
    }

    return (
        <>
            <IconButton
                size="small"
                onClick={handleOpen}
                aria-label="Ações"
            >
                <MoreHorizIcon fontSize="small" />
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={aberto}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                {mostrarConfirmar && (
                    <MenuItem onClick={() => executar(onConfirmar)} disabled={!podeConfirmar}>
                        <ListItemIcon>
                            <CheckCircleOutlineIcon fontSize="small" color="success" />
                        </ListItemIcon>
                        <ListItemText>Confirmar</ListItemText>
                    </MenuItem>
                )}

                {mostrarIntegrar && (
                    <MenuItem onClick={() => executar(onIntegrar)} disabled={!podeIntegrar}>
                        <ListItemIcon>
                            <SyncOutlinedIcon fontSize="small" color="primary" />
                        </ListItemIcon>
                        <ListItemText>Integrar</ListItemText>
                    </MenuItem>
                )}

                {mostrarDesconfirmar && (
                    <MenuItem onClick={() => executar(onDesconfirmar)} disabled={!podeDesconfirmar}>
                        <ListItemIcon>
                            <UndoOutlinedIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Desconfirmar</ListItemText>
                    </MenuItem>
                )}

                {mostrarIgnorar && (
                    <MenuItem onClick={() => executar(onIgnorar)} disabled={!podeIgnorar}>
                        <ListItemIcon>
                            <BlockOutlinedIcon fontSize="small" color="error" />
                        </ListItemIcon>
                        <ListItemText>Ignorar</ListItemText>
                    </MenuItem>
                )}

                {mostrarReconsiderar && (
                    <MenuItem onClick={() => executar(onReconsiderar)} disabled={!podeReconsiderar}>
                        <ListItemIcon>
                            <RestoreOutlinedIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Reconsiderar</ListItemText>
                    </MenuItem>
                )}

                <MenuItem onClick={() => executar(onVerHistorico)} disabled={!temHistorico}>
                    <ListItemIcon>
                        <HistoryOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Ver histórico</ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
};

export default React.memo(MenuAcoesIntegracao);
